// generated by bun run generate from the SwiftUI SDK and codegen/catalog.ts.
// edit the generator or catalog, then regenerate.
import type { ColorValue, ViewProps } from 'react-native';
import codegenNativeComponent from 'react-native/Libraries/Utilities/codegenNativeComponent';
interface NativeProps extends ViewProps {
  sizing: string;
  colorScheme: string;
  dynamicTypeSize: string;
  controlSize: string;
  locale: string;
  tint?: ColorValue;
  isEnabled: string;
}
const NativeComponentRegistry = require('react-native/Libraries/NativeComponent/NativeComponentRegistry');
let nativeComponentName = 'OneNativeForm';
export const __INTERNAL_VIEW_CONFIG = {
  uiViewClassName: "OneNativeForm",
  validAttributes: {
    sizing: true,
    colorScheme: true,
    dynamicTypeSize: true,
    controlSize: true,
    locale: true,
    tint: require('react-native/Libraries/Components/View/ReactNativeStyleAttributes').colorAttribute,
    isEnabled: true
  }
};
export default NativeComponentRegistry.get(nativeComponentName, () => __INTERNAL_VIEW_CONFIG);